<template>
    <div class="TaskIndex spackage padding-20 bgc box-shadow">
       <div class="head">
            <div class="flex left">
                <!-- <router-link :to='{name:"TaskActivityEdit"}'><el-button type="primary">新增活动</el-button></router-link> -->
                <el-button @click='handleAdd' type="primary">新增活动</el-button>
            </div>
            <div class="flex right">
                <!-- <el-date-picker v-model="times" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"  class="item"></el-date-picker> -->
                <el-select v-model="apidata.status" class="select item " placeholder="活动状态">
                    <el-option v-for="item in status" :key="item.key" :label="item.label" :value="item.key"></el-option>
                </el-select>
                <el-select v-model="apidata.resulttype" class="select item " placeholder="凭证类型">
                    <el-option v-for="item in voucherType" :key="item.key" :label="item.label" :value="item.key"></el-option>
                </el-select>
                <el-select v-model="apidata.asstype" class="select item " placeholder="助力类型">
                    <el-option v-for="item in assistanceType" :key="item.key" :label="item.label" :value="item.key"></el-option>
                </el-select>
                <el-input style="width:200px" v-model="apidata.title" placeholder="请输入活动名称" class="input item"></el-input>
                <el-button type="primary" @click="search" class="item">搜索</el-button>
            </div>
       </div>
        <el-table rel="singleTable" :data="tableInfo" style="width: 100%;">
            <el-table-column fixed  label="活动名称" align="left"  width="300">
                <template slot-scope="scope">
                    <div class="nameBox">
                        <div class="iconBox">
                            <img :src="scope.row.coveratturlid" :alt="scope.row.title" v-if="scope.row.coveratturlid !== ''">
                            <div v-else class='iconBox-block'></div>
                        </div>
                        <div class="rightBox">
                            <div class="title">
                                <el-tooltip class="item" effect="dark" :content="scope.row.title" placement="top-start">
                                    <div class="text">{{scope.row.title}}</div>
                                </el-tooltip>
                                <!-- <div class="text">{{scope.row.title}}</div> -->
                            </div>
                            <!-- <div class="type4">{{scope.row.resulttype == 1?'普通型': scope.row.resulttype == 4?'核销型':'配送型'}} {{scope.row.onlinetype == 1?'一次性上架':'滚动上架'}} </div> -->
                            <div class="type4">{{ scope.row.resulttypename }} {{ scope.row.asstypename }} </div>
                        </div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column property="asscount" label="助力人数" align="center">
            </el-table-column>
            <el-table-column property="assprice" label="助力价格" align="center"></el-table-column>
             <el-table-column property="viewcount" label="浏览量"  align="center"></el-table-column>
             <el-table-column property="ordercount" label="总订单数"  align="center"></el-table-column>
             <el-table-column property="ordersucccount" label="成交单数"  align="center"></el-table-column>
             <el-table-column property="totalpoundage" label="成交金额" width="160" align="center"></el-table-column>
             <el-table-column property="status" label="状态" align="center">
                 <template slot-scope="scope">
                   <!-- 待发布、进行中、暂停中、已完成、已取消 -->
                   <p :class="{'type-1': scope.row.status === 10,'type-2': scope.row.status === 100 || scope.row.status === 30 ,
                   'type-3': scope.row.status === 9,'type-4': scope.row.status === 11}">{{scope.row.statusname}}</p>
                 </template>
             </el-table-column>
             <el-table-column label="操作" align="right" width="300">
                 <template slot-scope="scope">
                    <div class="position">
                    
                      <template v-if='scope.row.status == 30'>
                        <p @click="goto('TaskActivityEdit', scope.row.eventinnerid)">详情</p>|
                        <p @click="goto('PosterManagement', scope.row.eventinnerid, scope.row.title)">海报</p>|
                         <el-dropdown>
                                <p>更多</p>
                                <el-dropdown-menu>
                                    <el-dropdown-item @click.native="seeOrderClick(scope.row)">查看订单</el-dropdown-item>
                                    <el-dropdown-item @click.native="chargeOffClick(scope.row)" v-if="scope.row.resulttype === 4">核销列表</el-dropdown-item>
                                    <!-- 类型为核销显示 -->

                                    <el-dropdown-item @click.native="helpRankClick(scope.row)" v-if="scope.row.isdisplayrank  === 1">助力排行</el-dropdown-item>
                                    <!-- 排行开启显示 -->
                                </el-dropdown-menu>
                          </el-dropdown>
                      </template>
                      <!-- 结束情况下 -->

                      <template v-else-if='scope.row.status == 100'>
                          <p @click="goto('TaskActivityEdit', scope.row.eventinnerid)">详情</p>
                      </template>
                      <!-- 取消情况下 -->

                      <template v-else>
                        <p @click="goto('TaskActivityEdit', scope.row.eventinnerid)">编辑</p>|
                        <p @click="goto('PosterManagement', scope.row.eventinnerid, scope.row.title)">海报</p>|
                        <p @click="shareActive(scope.row.shareeventurl)">分享</p>|
                        <el-dropdown>
                                <p>更多</p>
                                <el-dropdown-menu>
                                    <el-dropdown-item @click.native="shareSetClick(scope.row)">分享设置</el-dropdown-item>
                                    <el-dropdown-item @click.native="msgSetClick(scope.row)">客服信息配置</el-dropdown-item>
                                    <el-dropdown-item @click.native="seeOrderClick(scope.row)">查看订单</el-dropdown-item>

                                    <el-dropdown-item @click.native="CDKClick(scope.row)" v-if="scope.row.resulttype === 3">兑换码</el-dropdown-item>
                                    <!-- 类型为兑换码显示 -->

                                    <el-dropdown-item @click.native="chargeOffClick(scope.row)" v-if="scope.row.resulttype === 4">核销列表</el-dropdown-item>
                                    <!-- 类型为核销显示 -->
                                    
                                    <el-dropdown-item @click.native="helpRankClick(scope.row)" v-if="scope.row.isdisplayrank  === 1">助力排行</el-dropdown-item>
                                    <!-- 排行开启显示 -->
                                    <el-dropdown-item @click.native="stopActive(scope.row.eventinnerid)" v-if='scope.row.status == 10'>暂停活动</el-dropdown-item>
                                    <el-dropdown-item @click.native="updateActiveStatus(scope.row.eventinnerid, 10)(scope.row.eventinnerid)" v-if='scope.row.status == 11'>恢复活动</el-dropdown-item>
                                    <el-dropdown-item @click.native="endActive(scope.row.eventinnerid)">结束活动</el-dropdown-item>
                                    <el-dropdown-item @click.native="updateActiveStatus(scope.row.eventinnerid, 100)" v-if='scope.row.status == 9'>删除活动</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                      </template>
                      <!-- 正常情况下 -->

                    </div>
                 </template>
             </el-table-column>
        </el-table>

        <el-pagination background layout="prev, pager, next" :total="totalPage"  @current-change="fPage"></el-pagination>


        <ActiveType :activeType='activeType' @closeActiveType='closeActiveType'></ActiveType>
        <CopyShareDialog :shareeventurl="shareeventurl" :imgurl="imgurl" :copyShareStatus='copyShareStatus' @closeCopyShareStatus='closeCopyShareStatus'></CopyShareDialog>
        <div class="help_rank_pop_box">
            <HelpRankPop ref="helpRankList"></HelpRankPop>
        </div>
    </div>
</template>

<script>
import fecha from 'element-ui/src/utils/date'
import { urlToQRCode} from 'common/js/tools'
import { mapActions} from 'vuex' // 引入 vuex 组件
import $ from 'jquery'
import {checkModule} from '@/api/api'
import {getEventInfoList, updateEventByStatus, saveCopyEvent} from 'api/cPurchaseApi'
import {getAssEventList, updateAssEventStatus, getAssEventRankList} from 'api/taskToolsApi'
import ActiveType from './components/ActiveType.vue'
import CopyShareDialog from './components/CopyShareDialog'
import HelpRankPop from 'views/taskTools/helpManagement/components/HelpRankPop'

export default {
        name: "TaskIndex",
        data() {
          return {
              activeType: false,
              imgurl: '', 
              tableInfo: [],    //表单数据
              voucherType: [{key: '', label: '全部凭证'},{key: 1, label: '普通型'},{key: 3, label: '兑换码'},{key: 4, label: '核销型'},{key: 5, label: '配送型'}], // 凭证类型
              assistanceType: [{key: '', label: '全部类型'},{key: 1, label: '阅读助力'},{key: 2, label: '公众号助力'},{key: 3, label: '砍价助力'}], // 助力类型
              status: [{key: '', label: '全部状态'},{key: 9, label: '未开始'},{key: 10, label: '进行中'},{key: 11, label: '暂停中'},{key: 30, label: '已结束'},{key: 100, label: '已取消'}], // 状态位
              totalPage: 0,    //数据条数
              copyShareStatus: false, // 分享状态
              copyDialogVisibleStatus: false, // 控制复制活动的弹窗
              currentPage: 1, // 当前页
              shareeventurl: '', // 分享链接
              apidata: {
                status: '',     // 状态
                title: '',      // 活动名称
                asstype: '', // 助力类型
                resulttype : '', // 凭证类型
                page: '',       // 当前页数
                pagesize: 10    // 每页展示条数
              }

          }
        },
        mounted() {
            this.activelist(1)
        },
        methods: {
            // 新增活动
            handleAdd() {
                var params = {
                    moduleid: 'A20'
                }
                checkModule({
                    data: Object.assign({}, params),
                    success: data => {
                        this.activeType = true
                    },
                    error: data => {
                        console.log('error：', data)
                        this.$message.error(data.msg)
                    }
                })
            },
            activelist(page) {  // 活动列表
                this.apidata.page = page    // 取得页数
                this.setLoading(true)

                getAssEventList({
                    data: this.apidata,
                    success: data => {

                        this.tableInfo = data.data.content
                        this.totalPage = data.data.pageinfo.rowCount

                        console.log(data)
                        this.setLoading(false)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }   
                })
            },
            closeActiveType(val) {  // 弹窗关闭
                this.activeType = false
            },
            search() {  // 搜索
                this.activelist(1) 
            },  
            closeCopyShareStatus(val) { // 关闭复制弹窗
                this.copyShareStatus = false
            },
            fPage(){    // 分页
                let clickPage = $(".el-pagination .active").html()
                this.activelist(clickPage)
            },
            goto(name, eventinnerid, title) {    // 前往其他页面
                this.$router.push({name: name, query: {'eventinnerid': eventinnerid, 'title': title}})
            },
            updateActiveStatus(eventinnerid, status) {  // 修改活动状态

                let data = { eventinnerid: eventinnerid, status: status}
                this.setLoading(true)

                updateAssEventStatus({
                    data: data,
                    success: data => {
                        this.$message.success('操作成功')
                        this.activelist(this.apidata.page)
                        this.setLoading(false)
                    },
                    error: data => {
                        this.$message.error(data.msg)
                        this.setLoading(false)
                    }
                    
                })
            },
            delActive(innerid) {    // 删除活动
                let data = {eventinnerid:innerid,status:100}
                this.setLoading(true)
            
                updateEventByStatus({
                    data: data,
                    success: data => {
                        this.$message.success('操作成功')
                        this.setLoading(false)
                        this.activelist(this.apidata.page)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                        
                })
            },
            stopActive(innerid) {   // 暂停活动
                this.$confirm('您确认暂停活动？','暂停提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.updateActiveStatus(innerid, 11)
                }).catch(() => {})
            },
            endActive(innerid) {    // 结束活动
                this.$confirm('活动结束将无法再次开启，您确定结束活动？', '结束提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                 }).then(() => {
                    this.updateActiveStatus(innerid, 30)
                }).catch(() => {})         
            },
            shareActive(shareeventurl) {  // 分享活动
                this.copyShareStatus = true
                this.shareeventurl = shareeventurl
                this.imgurl = urlToQRCode(shareeventurl)

            },
            // 分享设置
            shareSetClick(val) {
                // console.log(val)
                this.$router.push({name: 'ShareSet', query: {eventinnerid: val.eventinnerid}})
            },
            // 客服消息设置
            msgSetClick(val) {
                // console.log(val)
                this.$router.push({name: 'MsgSet', query: {eventinnerid: val.eventinnerid, asstype: val.asstype}})
            },
            // 查看订单
            seeOrderClick(val) {
                // console.log(val)
                this.$router.push({name: 'TaskOrderAdmin', query: {eventinnerid: val.eventinnerid}})
            },
            // 兑换码
            CDKClick(val) {
                // console.log(val)
                this.$router.push({name: 'Cdklist', query: {eventinnerid: val.eventinnerid}})
            },
            // 核销列表
            chargeOffClick(val) {
                // console.log(val)
                this.$router.push({name: 'ChargeOffList', query: {eventinnerid: val.eventinnerid}})
            },
            // 助力排行
            helpRankClick(val) {
                // console.log(val)
                this.$refs.helpRankList.openDialog(val)
            },
            ...mapActions([
                'setLoading'
            ])
        },
        components: {
            ActiveType,
            CopyShareDialog,
            HelpRankPop
        }
    }
</script>

<style lang="scss" type="text/scss">
    .el-message-box__content {
        padding: 30px 50px!important;
        text-align: center!important;
        color: #F56C6C!important;
    }
    .el-message-box__btns {
        text-align: center!important;
        .el-button {
            margin-bottom: 30px!important;
        }
    }
    .el-tooltip__popper.is-dark {
        background: #000
    }
    .TaskIndex {
        .one-title {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .sub-title {
            display: -webkit-box;
            display: -webkit-inline-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            -moz-box-orient: vertical;
            -ms-box-orient: vertical;
            box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .el-input__icon {
            line-height: normal;
        }
        .head {
            margin-bottom: 30px;
        }

        .position,
        .head,
        .flex {
            display: flex;
            flex-wrap: nowrap;
            -ms-flex-wrap: nowrap;
            width: 100%;
        }
        .flex.left {
            align-content: flex-start;
        }
        .flex.right {
            align-content: flex-end;
        }

        .head {
            .select {
                width: 108px;
            }
            .input {
                width: 134px;
            }
            .item {
                margin-left: 15px
            }
        }
        .el-pagination {
            margin-top: 20px;
            text-align: center;
        }

        .position {
            color: #439FFE;
            width: auto;
            float: right;

            p {
                margin: 0 5px;
                color: #439FFE;
                cursor: pointer;
            }
        }
        
        .type-1 {
            color: #67C23A
        }
        .type-2 {
            color: #606266  
        }
        .type-3 {
            color: #F56C6C 
        }
        .type-4 {
            color: #E6A23C
        }
        .help_rank_pop_box {
            .el-dialog__wrapper {
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: left;
            }
            .el-dialog {
                width: 678px;
                margin: 0!important;
            }
        }

        .nameBox{
            display: flex;
                .iconBox{
                    width: 106px;
                    height: 60px;
                    margin-right: 10px;
                    img{
                        min-width: 106px;
                        width: 106px;
                        height: 60px;
                    }
                }
                .iconBox-block {
                    display: block;
                    width: 106px;
                    height: 60px;
                    background: #ccc
                }
                .rightBox{
                    min-width: 104px;
                    display: flex;
                    flex-direction: column;
                    .title{
                        height: 40px;
                        line-height: 20px;
                        overflow: hidden;
                        .text{
                            // float: right;
                            /* "margin-left"要等于".wrap::before"的宽度 */
                            // margin-left: -10px;
                            width: 100%;
                            word-break: break-all;
                            text-align: left;
                            font-size: 14px;
                            // font-size: 0.48rem;
                        }
                        // &::before {
                        //     float: left;
                        //     content: '';
                        //     width: 10px;
                        //     height: 100%;
                        // }
                        &::after {
                            float: right;
                            content: "...";
                            /* 行高与".wrap"设置的一致即可 */
                            height: 40px;
                            line-height: 20px;
                            /* 设置三个省略号的宽度,大于字体文本宽度即可,数值随意。并使盒子不占位置 */
                            width: 37px;
                            margin-left: -37px;
                            /* 移动省略号位置 */
                            position: relative;
                            left: 101.9%;
                            bottom: 20px;
                            font-weight: 600;
                            padding-right: 1px;
                            background: #fff;
                            transition: all 0.5s;
                            text-align: left;
                        }
                    }
                    .type{
                        text-align: left;
                    }
                    .type1{
                        color: #67C23A;
                    }
                    .type2{
                        color: #409EFF;
                    }
                    .type3{
                        color: #E6A23C;
                    }
                    .type4{
                        text-align: left;
                        color:  #F56C6C;
                    }
                }
            }

    }
</style>